import React, { Component } from 'react';
import { CircularProgress } from 'material-ui';

export class LoadingComponent extends Component {

    render() {
        return <div className='loading' key='loading'>
            <CircularProgress color='primary' size={70} thickness={7} />
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/shared/loading/loading.component.js